import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/catalyst-ui/table'
import { Button } from '@/components/catalyst-ui/button'
import { Dropdown, DropdownButton, DropdownMenu, DropdownItem } from '@/components/catalyst-ui/dropdown'
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid'

export default function DNSRecordsTable({ records, onDelete, onEdit, isViewer = false }) {
  return (
    <div className="space-y-4">
      {/* Desktop Table */}
      <div className="block">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Type</TableHeader>
              <TableHeader>Host</TableHeader>
              <TableHeader>Value</TableHeader>
              <TableHeader>TTL</TableHeader>
              <TableHeader></TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {records.map((record) => (
              <TableRow key={record.id}>
                <TableCell className="font-medium ">{record.type}</TableCell>
                <TableCell className="font-normal text-sm text-[#71717B]">
                  {record.host}
                </TableCell>
                <TableCell className="font-normal text-sm max-w-[20rem] md:max-w-2 overflow-hidden text-ellipsis whitespace-nowrap">
                  {record.value}
                </TableCell>
                <TableCell className="font-normal text-sm">
                  {record.ttl}
                </TableCell>
                <TableCell>
                  {!isViewer && (onDelete || onEdit) && (
                    <div className="flex items-center justify-end gap-2">
                      <Dropdown>
                        <DropdownButton
                          as={Button}
                          plain
                          className="p-1 hover:bg-gray-100 rounded transition-colors data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
                          title="More options"
                        >
                          <EllipsisVerticalIcon className="!w-5 !h-5" />
                        </DropdownButton>
                        <DropdownMenu className="min-w-40">
                          {onEdit && (
                            <DropdownItem onClick={() => onEdit(record)}>
                              Edit Record
                            </DropdownItem>
                          )}
                          {onDelete && (
                            <DropdownItem 
                              onClick={() => onDelete(record)}
                              className="hover:!bg-[#B91C1C]/10 hover:!text-[#B91C1C]"
                            >
                              Delete Record
                            </DropdownItem>
                          )}
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

    
    </div>
  )
 }